<template>
  <div class="accessories-page">
    <!-- Banner Section -->
    <div class="banner-section">
      <h1 class="banner-title">配件</h1>
    </div>

    <!-- Main Content Section -->
    <div class="main-content">
      <!-- Navigation Tabs -->
      <div class="nav-tabs">
        <div class="nav-item"
             v-for="(item, index) in accessories"
             :key="item.id"
             @click="currentTab = index"
             :class="{ active: currentTab === index }">
          <div class="nav-img-wrapper">
            <img :src="item.thumb"
                 :alt="item.name"
                 class="nav-img">
          </div>
          <div class="nav-name">{{ item.name }}</div>
        </div>
      </div>

      <!-- Content Area -->
      <div class="content-area"
           v-if="currentAccessory">
        <!-- Left Text -->
        <div class="text-column">
          <ul class="feature-list">
            <li v-for="(feature, idx) in currentAccessory.features"
                :key="idx"
                class="feature-item">
              <!-- <span class="bullet">·</span> -->
              <span class="feature-text">{{ feature }}</span>
            </li>
          </ul>
        </div>

        <!-- Right Image -->
        <div class="image-column">
          <img :src="currentAccessory.image"
               :alt="currentAccessory.name"
               class="detail-img">
          <div class="product-label"
               v-if="currentAccessory.labelImage">
            <img :src="currentAccessory.labelImage"
                 alt="Logo"
                 class="label-img">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessoriesPage',
  data() {
    return {
      currentTab: 0,
      accessories: [
        {
          id: 'purifier',
          name: '烟雾净化器',
          // 使用占位图，实际开发请替换为真实图片路径
          thumb: require('@/assets/product/accessories/ywjhq.png'),
          image:require('@/assets/product/accessories/ywjhq.png'),
          features: [
            "· 适用场所：适用于所有会产生烟雾、异味、粉尘、有毒有害气体等空气污染的场所。",
            "· 应用领域：涵盖电子电器、玩具制造、精密五金、医疗等领域。",
            "· 设计特点：采用可变式的单、双工位设计。",
            "· 过滤装置：配备多层过滤装置。",
            "· 风量调节：可根据废气产生量对风量大小进行无极调节。",
            "· 净化效果：能有效地吸附和过滤，净化率高达 99.97%。",
            "· 空气排放：净化处理后的洁净空气可直接在室内释放。"
          ]
        },
        {
          id: 'rotary',
          name: '旋转轴',
          thumb: require('@/assets/product/accessories/xzz.png'),
          image: require('@/assets/product/accessories/xzz.png'),
          features: [
        "· 设备类型：辅助激光切割 / 雕刻机器加工的设备。",

        "· 用途：实现工件旋转运动。",

        "· 适配加工对象：圆柱状、管状等物体。",

        "· 拓展功能：使激光切割 / 雕刻机器从只能加工平面板材，拓展到可对圆柱体进行加工。"
          ]
        },
        {
          id: 'riser',
          name: '增高台',
          thumb: require('@/assets/product/accessories/zgt.png'),
          image: require('@/assets/product/accessories/zgt.png'),
          features: [
            "· 高效成型机，提供精确的成型加工。",
            "· 数控系统控制，操作简便。",
            "· 多种成型模具可选。",
            "· 快速装夹系统，提高工作效率。",
            "· 安全防护装置齐全。",
            "· 适用于多种材料成型加工。"
          ]
        }
      ]
    }
  },
  computed: {
    currentAccessory() {
      return this.accessories[this.currentTab];
    }
  }
}
</script>

<style scoped>
.accessories-page {
  width: 100%;
  background-color: #fff;
  padding-bottom: 100px;
}

/* Banner Section */
.banner-section {
  width: 100%;
  height: 648px;
  /* 使用浅蓝色渐变模拟图中的背景 */
  background: linear-gradient(135deg, #e0f2ff 0%, #f0f9ff 100%);
  background-image: url("@/assets/product/accessories/banner.png"); /* 抽象背景 */
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-title {
  font-size: 60px;
  color: #12151a;
  font-weight: normal; /* 不加粗 */
  letter-spacing: 2px;
}

/* Main Content */
.main-content {
  width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
}

/* Nav Tabs */
.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 120px; /* 间距 */
  margin-bottom: 100px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-img-wrapper {
  width: 260px; /* 根据截图估计 */
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  /* 增加一点悬浮效果 */
  transition: transform 0.3s;
}

.nav-item:hover .nav-img-wrapper {
  transform: translateY(-5px);
}

.nav-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nav-name {
  font-size: 20px;
  color: #333;
  transition: color 0.3s;
}

/* 激活状态 */
.nav-item.active .nav-name {
  color: #2ea2fa;
}

/* Content Area */
.content-area {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: space-between;
  min-height: 500px;
}

.text-column {
  width: 50%;
  padding-right: 40px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 16px;
  color: #666;
}

.bullet {
  color: #2ea2fa;
  font-weight: bold;
  margin-right: 10px;
  font-size: 20px;
  line-height: 1.8; /* 对齐文字 */
}

.feature-text {
  flex: 1;
}

.image-column {
  width: 45%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.detail-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: 500px;
}

.product-label {
  margin-top: 20px;
}
</style>